import { useEffect, useState } from 'react';
import {
  Card,
  HStack,
  Icon,
  Typography,
  VStack,
} from '@vivaahealth/design-system';

import * as api from '../../api';

import { format } from '../../utils/location';

import styles from './index.module.css';

interface Props {
  name: string;
  address: api.Address.Address;
  onRemove: () => void;
}
export const ResultCard = ({ name, address, onRemove }: Props) => {
  const [staticMapUrl, setStaticMapUrl] = useState<string | undefined>();

  useEffect(() => {
    const { longitude, latitude } = address;
    if (longitude === null || latitude === null) return;
    api.client.Maps.getStaticMapUrl({
      longitude: `${longitude}`,
      latitude: `${latitude}`,
    }).then(setStaticMapUrl);
  }, [address]);

  return (
    <Card>
      <Card.Header background="gray">
        <HStack justifyContent="space-between" width="100%" alignItems="center">
          <Typography variant="title-large" bold>
            {name}
          </Typography>
          <Icon.X
            stroke={'#EB4747'}
            onClick={onRemove}
            size="large"
            cursor="pointer"
          />
        </HStack>
      </Card.Header>
      <Card.Body>
        <VStack gap={16}>
          <Typography variant={'paragraph-medium'}>
            {format(address)}
          </Typography>
          {staticMapUrl && (
            <img
              className={styles.StaticMap}
              src={staticMapUrl}
              alt={'Pharmacy Location'}
            />
          )}
        </VStack>
      </Card.Body>
    </Card>
  );
};
